<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/13rsvmY/tc-custom/9780226740966.jpg?1722574796205" alt="This image is the cover for the book Eighth"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Eighth
      </h1>
      <p class="bookDescription body article font2">
        <b>This “thrilling study of Gustav Mahler’s Symphony No 8 . . . makes a strong case for its quality . . . we shall never listen to it in the same way again” (<i>Guardian</i>, UK).</b><br/><br/>On September 12, 1910, Gustav Mahler’s Eighth Symphony had its world premiere at Munich’s new Musik Festhalle. It was the artistic breakthrough for which the composer had yearned all his life. An array of royals and stars from the musical and literary world were in attendance, including Thomas Mann and the young Arnold Schoenberg. Also present were Alma Mahler, the composer’s wife, and Alma’s longtime lover, the architect Walter Gropius. <br/><br/>In <i>The Eighth</i>, Stephen Johnson provides a masterful account of the symphony’s far-reaching consequences and its effect on composers, conductors, and writers of the time. <i>The Eighth</i> looks behind the scenes at the demanding one-week rehearsal period leading up to the premiere—something unheard of at the time—and provides fascinating insight into Mahler’s compositional habits, his busy life as a conductor, his philosophical and literary interests, and his personal and professional relationships. <br/><br/>Johnson expertly contextualizes Mahler’s work among the prevailing attitudes and political climate of his age, considering the art, science, technology, and mass entertainment that informed the world in 1910. <i>The Eighth</i> is an absorbing history of a musical masterpiece and the troubled man who created it.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stephen Johnson
      </h2>
      
      <p class="authorDescription body article"><B>Stephen Johnson</B>&#160;is a writer&#160;and&#160;composer,&#160;as well as a regular&#160;broadcaster&#160;for BBC Radio. He is the author of&#160;<I>Bruckner Remembered</I>&#160;and&#160;<I>How Shostakovich Changed My Mind</I>.&#160;He writes for the&#160;<I>Independent</I>,&#160;<I>Guardian</I>,&#160;<I>BBC Music Magazine</I>,&#160;and&#160;<I>Gramophone</I>.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2d7e8dc7